<template>
  <section>
    <form @submit.prevent="handleSubmit" class="form-signin">
    <h3>Reset Password</h3>

    <div class="form-group">
        <input type="password" class="form-control" v-model="password" placeholder="Password" required>
    </div>

    <div class="form-group">
        <input type="password" class="form-control" v-model="confirm_password" placeholder="Confirm Password" required>
    </div>

    <button class="btn btn-primary btn-block">Password Confirm</button>
  </form>
  </section>

</template>

<script>
import axios from 'axios';

export default {
    name: 'ResetPassword',
    data() {
        return {
            password: '',
            confirm_password: ''
        }
    },
    methods: {
        async handleSubmit() {
            const response = await axios.patch('set-new-password/', {
                password: this.password,
                confirm_password: this.confirm_password,
                uidb64: this.$route.params.uidb64,
                token: this.$route.params.token
            });

            console.log(response);
            this.$router.push('/login')
        }
    }

}
</script>

<style scoped>
  .form-signin {
    width: auto;
    max-width:400px;
    padding: 15px;
    margin: auto;
    margin-top: 300px;
  }
  
  .form-signin .checkbox {
    font-weight: 400;
  }
  
  .form-signin .form-floating:focus-within {
    z-index: 2;
  }
  
  .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
</style>